import Auth from './auth/reducer';
import Compare from './compareDoc/reducers';
import Header from './pageheader/reducer';
import App from '@iso/redux/app/reducer';
import Breadcrumb from './breadcrumbs/reducer';
import Xero from '@iso/redux/xero/reducers';
import ThemeSwitcher from '@iso/redux/themeSwitcher/reducer';

export default {
  Auth,
  App,
  Xero,
  Compare,
  ThemeSwitcher,
  Breadcrumb,
  Header,
};
